import makeActionCreator from '../make-action-creator';
import * as constants from '../constants';

export const setLocation = makeActionCreator(constants.SET_LOCATION, 'location');
export const setStyle = makeActionCreator(constants.SET_STYLE, 'style');
export const setText = makeActionCreator(constants.SET_TEXT, 'text');
export const setSize = makeActionCreator(constants.SET_SIZE, 'size');
export const setOrder = makeActionCreator(constants.SET_ORDER, 'state');
export const setIsLoading = makeActionCreator(constants.SET_IS_LOADING, 'state');